// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accordion/accordion.component.scss
// module id = 147
// module chunks = 0